import {
    Box, Grid,
    Typography
} from '@mui/material'
import React, { useContext } from 'react'
import { useEffect } from 'react'
import Coupon from '../services/db/coupon'
import { InfoContext } from '../services/Context/Info/context'
import AddCoupon from './elements/AddCoupon'


const Coupons = () => {
    const { data: { couponData }, setData } = useContext(InfoContext);
    useEffect(() => {
        if (!couponData.length) new Coupon().allCoupons().then(r => {
            setData(p => ({ ...p, couponData: r }))
        })
    }, []);

    return (
        <Box sx={{ paddingX: 5, height: '100%' }}>
            <Grid container direction='column' paddingTop={2} spacing={5} minHeight='100%'>
                <Grid item xs={12} paddingY={1}>
                    <Typography>Coupons</Typography>
                </Grid>
                <Grid item container xs={12} spacing={2}>
                    <Grid item xs={12} container spacing={1} justifyContent='flex-end'>
                        <AddCoupon />
                    </Grid>
                </Grid>
                <Grid container rowSpacing={5} item xs={12} style={{ minHeight: '100%' }}>
                    {
                        couponData.map(el => (
                            <Grid
                                container
                                item
                                xs={12}
                                key={el.title}
                                sx={{
                                    backgroundColor: '#FAF0E6',
                                    marginTop: 1,
                                    marginBottom: 1,
                                    padding: 2
                                }}
                            >
                                <Grid item xs={9}>
                                    <Typography>{el.title}</Typography>
                                    <Typography variant='h6'>Description</Typography>
                                    <br />
                                    <Typography>{el.description}</Typography>
                                </Grid>
                                <Grid
                                    item
                                    xs={3}
                                    display='flex'
                                    justifyContent='center'
                                    alignItems='center'
                                    flex={1}
                                >
                                    <AddCoupon data={el} />
                                </Grid>
                            </Grid>
                        ))
                    }
                </Grid>
            </Grid>
        </Box>
    )
}

export default Coupons